import { TSelectOptions } from '@/components/Select';
import useHomeContext from '@/hooks/useHomeContext';
import { updateTransactionReceiptExemptionReason } from '@/services/transactionHistory';
import { EnumValues } from '@/services/types/EnumValues';
import { ReceiptExemptionReasonEnum, TransactionTypeEnum } from '@/services/types/TransactionData';
import { useState } from 'react';

const useReceiptExemptionReason = () => {
  const { setError, selectedTransaction, setSelectedTransaction, setCurrentPageTransactions } =
    useHomeContext()!;
  const [receiptExemptionReason, setReceiptExemptionReason] = useState<TSelectOptions>();

  const handleReceiptExemptionReasonChanged = async (
    transactionId: string,
    option?: TSelectOptions
  ) => {
    if (option) {
      updateTransactionReceiptExemptionReason(transactionId, {
        receiptExemptionReason: option.value as EnumValues<typeof ReceiptExemptionReasonEnum>
      })
        .then(() => {
          setReceiptExemptionReason(option);

          if (selectedTransaction && selectedTransaction.type === TransactionTypeEnum.Purchase) {
            setSelectedTransaction((prev) => {
              if (prev) {
                return {
                  ...prev,
                  data: {
                    ...prev?.data,
                    receiptExemptionReason: option.value as EnumValues<
                      typeof ReceiptExemptionReasonEnum
                    >
                  }
                };
              }
            });
          }

          setCurrentPageTransactions((currTxns) =>
            currTxns.map((txn) =>
              txn.data.id === selectedTransaction?.data.id
                ? {
                    ...txn,
                    data: {
                      ...txn.data,
                      receiptExemptionReason: option.value as EnumValues<
                        typeof ReceiptExemptionReasonEnum
                      >
                    }
                  }
                : txn
            )
          );
        })
        .catch(() => {
          setError(
            'Something went wrong while updating receipt exemption reason. Please try again'
          );
        });
    } else {
      setReceiptExemptionReason(undefined);
    }
  };

  return { receiptExemptionReason, setReceiptExemptionReason, handleReceiptExemptionReasonChanged };
};

export default useReceiptExemptionReason;
